"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBytesDataType = void 0;

var ethereum_types_1 = require("ethereum-types");

var ethUtil = require("ethereumjs-util");

var _ = require("lodash");

var blob_1 = require("../abstract_data_types/types/blob");

var constants_1 = require("../utils/constants");

var StaticBytesDataType = /*#__PURE__*/function (_blob_1$AbstractBlobD) {
  _inherits(StaticBytesDataType, _blob_1$AbstractBlobD);

  var _super = _createSuper(StaticBytesDataType);

  function StaticBytesDataType(dataItem, dataTypeFactory) {
    var _this;

    _classCallCheck(this, StaticBytesDataType);

    _this = _super.call(this, dataItem, dataTypeFactory, StaticBytesDataType._SIZE_KNOWN_AT_COMPILE_TIME);

    if (!StaticBytesDataType.matchType(dataItem.type)) {
      throw new Error("Tried to instantiate Static Bytes with bad input: ".concat(dataItem));
    }

    _this._width = StaticBytesDataType._decodeWidthFromType(dataItem.type);
    return _this;
  }

  _createClass(StaticBytesDataType, [{
    key: "getSignatureType",
    value: function getSignatureType() {
      // Note that `byte` reduces to `bytes1`
      return "".concat(ethereum_types_1.SolidityTypes.Bytes).concat(this._width);
    }
  }, {
    key: "encodeValue",
    value: function encodeValue(value) {
      // 1/2 Convert value into a buffer and do bounds checking
      this._sanityCheckValue(value);

      var valueBuf = ethUtil.toBuffer(value); // 2/2 Store value as hex

      var valuePadded = ethUtil.setLengthRight(valueBuf, constants_1.constants.EVM_WORD_WIDTH_IN_BYTES);
      return valuePadded;
    }
  }, {
    key: "decodeValue",
    value: function decodeValue(calldata) {
      var valueBufPadded = calldata.popWord();
      var valueBuf = valueBufPadded.slice(0, this._width);
      var value = ethUtil.bufferToHex(valueBuf);

      this._sanityCheckValue(value);

      return value;
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      var valueBufPadded = constants_1.constants.EMPTY_EVM_WORD_BUFFER;
      var valueBuf = valueBufPadded.slice(0, this._width);
      var value = ethUtil.bufferToHex(valueBuf);
      return value;
    }
  }, {
    key: "_sanityCheckValue",
    value: function _sanityCheckValue(value) {
      if (typeof value === 'string') {
        if (!_.startsWith(value, '0x')) {
          throw new Error("Tried to encode non-hex value. Value must include '0x' prefix.");
        } else if (value.length % 2 !== 0) {
          throw new Error("Tried to assign ".concat(value, ", which is contains a half-byte. Use full bytes only."));
        }
      }

      var valueBuf = ethUtil.toBuffer(value);

      if (valueBuf.byteLength > this._width) {
        throw new Error("Tried to assign ".concat(value, " (").concat(valueBuf.byteLength, " bytes), which exceeds max bytes that can be stored in a ").concat(this.getSignature()));
      }
    }
  }], [{
    key: "matchType",
    value: function matchType(type) {
      return StaticBytesDataType._MATCHER.test(type);
    }
  }, {
    key: "_decodeWidthFromType",
    value: function _decodeWidthFromType(type) {
      var matches = StaticBytesDataType._MATCHER.exec(type);

      var width = matches !== null && matches.length === 3 && matches[2] !== undefined ? parseInt(matches[2], constants_1.constants.DEC_BASE) : StaticBytesDataType._DEFAULT_WIDTH;
      return width;
    }
  }]);

  return StaticBytesDataType;
}(blob_1.AbstractBlobDataType);

exports.StaticBytesDataType = StaticBytesDataType;
StaticBytesDataType._SIZE_KNOWN_AT_COMPILE_TIME = true;
StaticBytesDataType._MATCHER = RegExp('^(byte|bytes(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31|32))$');
StaticBytesDataType._DEFAULT_WIDTH = 1;